import { cn } from '../lib/cn';

export type BadgeKind = 'muted' | 'unread' | 'attention';

/**
 * Plakietka liczby w menu (Figma: Nav item v2): Muted — szara liczba mono (nic nowego),
 * Unread — pogrubiona ciemna liczba (coś nowego), Attention — niebieska plakietka (coś do zrobienia).
 * Liczba jest tylko wizualna (aria-hidden): miejsce użycia podaje ją czytnikom ekranu tekstem sr-only
 * („, nowe: 3”), żeby nazwa linku nie brzmiała „Inbox 3, nowe: 3”.
 */
export function Badge({ kind = 'muted', count, className }: { kind?: BadgeKind; count: number; className?: string }) {
  const text = count > 99 ? '99+' : String(count);
  if (kind === 'attention') {
    return (
      <span
        aria-hidden
        className={cn(
          'inline-flex h-[18px] min-w-[18px] shrink-0 items-center justify-center rounded-full bg-accent px-1.5',
          'text-micro font-semibold text-on-accent tabular',
          className,
        )}
      >
        {text}
      </span>
    );
  }
  return (
    <span
      aria-hidden
      className={cn(
        'shrink-0 text-caption tabular',
        kind === 'unread' ? 'font-semibold text-fg' : 'font-mono font-medium text-fg-muted',
        className,
      )}
    >
      {text}
    </span>
  );
}
